import { siteid1 } from './siteid1';
import { siteid70901 } from './siteid70901';
import { siteid70975 } from './siteid70975';
import { siteid70205 } from './siteid70205';
import { siteid70801 } from './siteid70801';
import { siteid509010011 } from './siteid509010011';
import { siteidEMEA } from './siteidEMEA';

/*
  Putting siteids based configuration should be avoided in Bernie. Try to check if that can be put inside bex-api layer itself. This needs to be discussed if there are no other alternatives.
*/

export const siteidOverrides = {
  siteid1,
  siteid70901,
  siteid70975,
  siteid70205,
  siteid70801,
  siteid509010011,
  ...siteidEMEA
};
